import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import { Guid, IApiLink, Lmid } from "@/types"
import CmmAsset, { IGetCmmAssetDto } from "./CmmAsset"
import LmidAsset, { IGetLmidAssetDto } from "./LmidAsset"

export enum ExistingLmidStatus {
    notUsed = "notUsed",
    active = "active",
    disposed = "disposed",
    usedInDifferentTenant = "usedInDifferentTenant",
}

export interface IGetExistingLmidDataDto {
    status: ExistingLmidStatus
    articleId?: Guid | null
    articleNo?: Guid | null
    articleDescription?: string | null
    lmid: Lmid
    assetId?: Guid | null
    isLabeled?: boolean | null
    cmmAsset?: IGetCmmAssetDto
    assets?: IGetLmidAssetDto[] | null
    drawingNo?: string | null
    constructionYear: number
    serialNumber?: string | null
    links?: IApiLink[]
}

export default class ExistingLmidData {
    status: ExistingLmidStatus
    articleId?: Guid
    articleNo?: string
    articleDescription?: string
    lmid: Lmid
    assetId?: Guid
    isLabeled?: boolean
    cmmAsset?: CmmAsset
    assets?: LmidAsset[]
    drawingNo?: string
    constructionYear: number
    serialNumber?: string
    createAssetLink?: IApiLink
    updateAssetLink?: IApiLink

    constructor(dto: IGetExistingLmidDataDto) {
        this.status = dto.status
        this.articleId = dto.articleId || undefined
        this.articleNo = dto.articleNo || undefined
        this.articleDescription = dto.articleDescription || undefined
        this.lmid = dto.lmid
        this.assetId = dto.assetId || undefined
        this.isLabeled = dto.isLabeled || undefined
        this.cmmAsset = dto.cmmAsset ? new CmmAsset(dto.cmmAsset) : undefined
        this.assets = dto.assets ? dto.assets.map(a => new LmidAsset(a)) : undefined
        this.drawingNo = dto.drawingNo || undefined
        this.constructionYear = dto.constructionYear
        this.serialNumber = dto.serialNumber || undefined
        this.createAssetLink = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.asset && lnk.rel === ApiLinkRel.new)
        this.updateAssetLink = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.asset && lnk.rel === ApiLinkRel.partialUpdate)
    }

    get isFoundInSingleTenant(): boolean {
        return !!this.assets && this.assets.length === 1
    }

    get isFoundInMultipleTenants(): boolean {
        return !!this.assets && this.assets.length > 1
    }
}
